import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputElementProps, MonetaryInput } from '../../UI/components/Form';
import { NoteReceivableFormValues } from '../types';

interface NoteReceivableEstimatedValueInputProps extends Pick<InputElementProps, 'required'> {
  className?: string;
}

export function NoteReceivableEstimatedValueInput({
  required = true,
  ...props
}: NoteReceivableEstimatedValueInputProps) {
  const { t: tForm } = useTranslation('form');
  const { control } = useFormContext<NoteReceivableFormValues>();
  const {
    field,
    formState: { errors },
  } = useController<NoteReceivableFormValues, 'estimatedValue'>({
    control,
    rules: { required },
    name: 'estimatedValue',
  });

  return (
    <MonetaryInput
      {...field}
      {...props}
      status={errors.estimatedValue ? 'errored' : 'normal'}
      label={tForm('note-receivable-estimated-value-input-label')}
      inputProps={{
        placeholder: required ? tForm('general-required-placeholder') : '',
      }}
    />
  );
}
